import { createRouter, createWebHistory } from 'vue-router'
import { hasKioskToken } from '@/features/kiosk/repository'

const routes = [
  {
    path: '/setup',
    name: 'setup',
    component: () => import('@/views/kiosk/SetupKiosk.vue'),

  },
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/kiosk/HomeView.vue'),
  },
  {
    path: '/pari',
    name: 'bet-type',
    component: () => import('@/views/kiosk/BetTypeView.vue'),
  },
  {
    path: '/favori',
    name: 'favorite',
    component: () => import('@/views/kiosk/FavoriteView.vue'),
  },
  {
    path: '/mise',
    name: 'stake',
    component: () => import('@/views/kiosk/StakeView.vue'),
  },
  {
    path: '/recapitulatif',
    name: 'summary',
    component: () => import('@/views/kiosk/SummaryView.vue'),
  },
  {
    path: '/ticket',
    name: 'ticket',
    redirect: { name: 'thanks' },
  },
  {
    path: '/merci',
    name: 'thanks',
    component: () => import('@/views/kiosk/ThanksView.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'home' },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to) => {
  const kioskToken = hasKioskToken()

  if (to.name !== 'setup' && !kioskToken) {
    return { name: 'setup' }
  }

  if (to.name === 'setup' && kioskToken && !to.query.token) {
    return { name: 'home' }
  }

  return true
})

// router.onError((error, to) => {
//   // Liste des erreurs typiques liées à un fichier JS introuvable après un déploiement
//   const isChunkLoadFailed = error.message.includes('Failed to fetch dynamically imported module') 
//                          || error.message.includes('Importing a module script failed');

//   if (isChunkLoadFailed) {
//     console.warn('Fichier obsolète détecté, rechargement forcé vers : ', to.fullPath);
//     // On force un rafraîchissement complet vers la page désirée
//     window.location.href = to.fullPath;
//   }
// });

export default router